import React, { useState } from "react";
import Navbar from "../components/General/Navbar";
import classes from "./Projects.module.css";
import ProjectsContainer from "../components/Projects/ProjectsContainer";
import ProjectCard from "../components/Projects/ProjectCard";
import ProjectsHeader from "../components/Projects/ProjectsHeader";
import trading from "../images/trading.png";
import event from "../images/eventLogo.png";
import unoportfolio from "../images/unoportfolio.jpeg";
import crypto from "../images/crypto.jpg";
import auction from "../images/auction.png";
import report from "../images/report.jpg";
import food from "../images/food.jpg";
import iyteapp from "../images/iyteapp.jpeg";
import invest from "../images/invest.jpg";
import VideoModal from "../components/Modals/VideoModal";

function Projects() {
  const [videoPath, setVideoPath] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = (path) => {
    setVideoPath(path);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Navbar onPage="Projects" />
      {modalOpen && <VideoModal onClose={closeModal} videoPath={videoPath} />}
      <ProjectsHeader />
      <ProjectsContainer>
        <ProjectCard
          title="Investing App"
          image={invest}
          content="This application, catering to investors of Borsa Istanbul, records and analyzes all their buying
          and selling transactions. It enables users to obtain accurate information about their current stock portfolio,
          enhanced with visual tools."
          video="/videos/investVideo.mp4"
          link="https://github.com/mertkaracax/InvestingAppFrontend"
          onOpen={openModal}
          display={true}
        />

        <ProjectCard
          title="Event App"
          image={event}
          content="The Event App is a social media platform designed for people to
              meet new individuals and accompany each other in various
              activities."
          link="https://github.com/mertkaracax/event-app-front"
          video="/videos/eventVideo.mp4"
          onOpen={openModal}
          display={true}
        />
        <ProjectCard
          title="Reporting Tool"
          image={report}
          content="Reporting Tool A more understandable, optimizated software 
           solution for the data that companies track and analyze via excel.
           "
          link="https://github.com/mertkaracax/ReportingTool"
          display={true}
        />
      </ProjectsContainer>
      <ProjectsContainer>
        <ProjectCard
          title="Food Order App"
          image={food}
          content="I utilized all of my React skills that I had learned up to
        that point in order to improve myself and reinforce my competencies in React technology. The project
        involved important topics such as Context, useReducer, useEffect, and similar concepts."
          link="https://github.com/mertkaracax/food-order-app"
          display={true}
        />
        <ProjectCard
          title="Trading Indicator"
          image={trading}
          content="A technical indicator with a high success rate that uses a mixture of various
          mathematical formulas, special conditions and various indicators, generating buy and sell signals on almost
          all investment instruments."
          display={true}
        />
        <ProjectCard
          title="Blank Component"
          image={trading}
          content="Lorem Ipsum"
          display={false}
        />
      </ProjectsContainer>
    </>
  );
}

export default Projects;
